module.exports = __webpack_public_path__ + "static/media/marriage.544453e3.svg";